import { ApiError } from '../types/ApiError';
import { ErrorTypes } from '../types/backendResponses/ErrorTypes';

// The backend's metadata.reason when an absence period that has gone to the payroll is to be
// changed, deleted or given another status. It may be the period being edited or another one
// that its new dates overlap, so the message covers both.
export const ABSENCE_EXPORTED = 'absenceExported';

export const absenceExportedMessage =
  'Frånvaron, eller en frånvaro som den överlappar, är redan exporterad till löneunderlaget och kan inte ändras eller tas bort.';

/** useAPI has already shown absenceExportedMessage for this error, so a caller must not replace it. */
export const isAbsenceExportedError = (error: ApiError): boolean =>
  error?.response?.data?.status === ErrorTypes.Conflict &&
  error.response.data.metadata?.reason === ABSENCE_EXPORTED;
